/**
 * Cluster class. Groups markers into a clickable circle with a number indicating how many markers it contains.
 * @param options
 * @constructor
 * @extends MapObject
 */
import {MapSVGMap} from "../Map/Map.js";
import {MapObject} from "../MapObject/MapObject.js";
import {Marker} from "../Marker/Marker.js";
import {ViewBox} from "../Map/MapOptionsInterface";
import {SVGPoint} from "../Location/Location";

const $ = jQuery;

export class MarkerCluster extends MapObject{ // extends MapObject
    mapsvg: MapSVGMap;
    svgPoint: SVGPoint;
    min_x: number;
    min_y: number;
    max_x: number;
    max_y: number;
    cellX: number;
    cellY: number;
    markers: Array<Marker>;
    cellSize: number;
    width: number;
    elem: HTMLElement;

    constructor(options: {svgPoint: SVGPoint, cellX: number, cellY: number, markers: Array<Marker>, width?: number, cellSize?: number }, mapsvg: MapSVGMap){
        super(null, mapsvg);

        this.svgPoint = options.svgPoint;
        this.cellX = options.cellX; // SVG-x (not pixel-x)
        this.cellY = options.cellY; // SVG-y (not pixel-y)
        this.markers = options.markers || [];

        this.cellSize = 50;
        this.width = 30;

        var _this = this;

        this.elem = $('<div class="mapsvg-marker-cluster">' + this.markers.length + '</div>')[0];
        $(this.elem).data("cluster", this);

        if (this.markers.length < 2) {
            $(this.elem).hide(); // don't show cluster at the start
        }

        this.adjustPosition();
    }

    /**
     * Adds marker to the cluster.
     * @param {Marker} marker
     */
    addMarker(marker: Marker) {
        this.markers.push(marker);
        if (this.markers.length > 1) {
            if (this.markers.length === 2) {
                // this.markers[0].clusterize();
                $(this.elem).show();
            }
            if (this.markers.length === 2) {

                var x = this.markers.map(function (m) {
                    return m.svgPoint.x
                });
                this.min_x = Math.min.apply(null, x);
                this.max_x = Math.max.apply(null, x);

                var y = this.markers.map(function (m) {
                    return m.svgPoint.y
                });
                this.min_y = Math.min.apply(null, y);
                this.max_y = Math.max.apply(null, y);

                this.svgPoint.x = this.min_x + ((this.max_x - this.min_x) / 2);
                this.svgPoint.y = this.min_y + ((this.max_y - this.min_y) / 2);
            }
            if (this.markers.length > 2) {
                if (marker.svgPoint.x < this.min_x) {
                    this.min_x = marker.svgPoint.x;
                } else if (marker.svgPoint.x > this.max_x) {
                    this.max_x = marker.svgPoint.x;
                }
                if (marker.svgPoint.y < this.min_y) {
                    this.min_y = marker.svgPoint.y;
                } else if (marker.svgPoint.x > this.max_x) {
                    this.max_y = marker.svgPoint.y;
                }
                this.svgPoint.x = this.min_x + ((this.max_x - this.min_x) / 2);
                this.svgPoint.y = this.min_y + ((this.max_y - this.min_y) / 2);
            }
            // marker.clusterize();
        } else {
            this.svgPoint.x = marker.svgPoint.x;
            this.svgPoint.y = marker.svgPoint.y;
        }

        $(this.elem).text(this.markers.length);
        this.adjustPosition();
    }

    /**
     * Checks if provided marker should be added into this cluster.
     * @param {MapSVG.Marker} marker
     * @returns {boolean}
     */
    canTakeMarker(marker: Marker): boolean {

        var _this = this;

        var screenPoint = _this.mapsvg.convertSVGToPixel(marker.svgPoint);

        return (this.cellX === Math.ceil(screenPoint.x / this.cellSize)
            &&
            this.cellY === Math.ceil(screenPoint.y / this.cellSize))
    }

    /**
     * Destroys the cluster
     */
    destroy() {
        // this.markers.forEach(function(marker){
        //     marker.unclusterize();
        // });
        this.markers = null;
        $(this.elem).remove();
    }

    /**
     * Adjusts position of the cluster.
     * Called on zoom and map container resize.
     */
    adjustPosition() {

        var _this = this;

        
        var pos = _this.mapsvg.convertSVGToPixel(this.svgPoint);

        if (pos.x > 30000000) {
            $(this.elem)[0].style.left = (pos.x - 30000000).toString();
            pos.x = 30000000;
        } else {
            $(this.elem)[0].style.left = (0).toString();
            // $(this.elem)[0].style.left = pos.x+'px';
        }
        if (pos.y > 30000000) {
            $(this.elem)[0].style.top = (pos.y - 30000000).toString();
            pos.y = 30000000;
        } else {
            $(this.elem)[0].style.top = (0).toString();
            // $(this.elem)[0].style.top = pos.y+'px';
        }

        pos.x -= this.width / 2;
        pos.y -= this.width / 2;

        $(this.elem).css({'transform':  'translate(' + pos.x + 'px,' + pos.y + 'px)'});
    };
    /**
     * Get SVG bounding box of the MarkersCluster
     * @returns {*[]} - [x,y,width,height]
     */
    getBBox(): ViewBox {

        var _this = this;

        var bbox = {
            x: this.svgPoint.x,
            y: this.svgPoint.y,
            width: this.cellSize / this.mapsvg.getScale(),
            height: this.cellSize / this.mapsvg.getScale()
        };
        bbox = $.extend(true, {}, bbox);

        return new ViewBox(bbox.x, bbox.y, bbox.width, bbox.height);
    };

    getData(){
        return this.markers.map( m => m.object );
    }
}